<template>
  <v-container>
     <v-row>
      <v-col cols="12" md="10" lg="8">
        <v-card>
          <v-card-title primary-title>
            Probar apis
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="enviar">Enviar</v-btn>
          </v-card-title>
          <v-card-text>
            <v-text-field 
            	v-model="path"
            	outlined
            	dense
            	label="url"
            ></v-text-field>
            <v-select
            	dense
              :items="['GET','POST']"
              v-model="metodo"
              label="Metodo"
              outlined
            ></v-select>
            <v-textarea 
           	  v-model="body"
            	outlined
            	dense
            	label="body"
            ></v-textarea>
            <div>
            	{{respuesta}}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title primary-title>
            Prueba de mercado pago
          </v-card-title>
          <v-card-actions>
            <v-btn color="primary" @click="pagarMercadoPago()">Pagar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
  import {mapActions, mapGetters} from 'vuex'
  // const axios = require('axios');


  export default {

    data: () => ({
      path:'',
      metodo:'',
      respuesta :'',
      body:'',
      // token:'798e40184c79642bd34b9678ad776e1ceeda2a9cd47ef3fb311c0dfcf6cf79b6'
      token:'3567c08abd08671458788c70ce41c241c75963365de74ee44bd8f3def40c3ddc'
      
    }),

    created(){

    },

    methods:{
    	enviar () {

				var config = {
				  method: this.metodo,
				  url: this.path,
				  headers: { 
				    'Content-Type': 'application/json', 
				    'Authorization': 'Bearer 3567c08abd08671458788c70ce41c241c75963365de74ee44bd8f3def40c3ddc'
				  },
				};

				if(this.body != ''){
					config.data = JSON.parse(this.body)
				}
				// axios(config)
				// .then((response) => {
				//   // console.log(JSON.stringify(response.data));
				//   this.respuesta = JSON.stringify(response.data)
				// })
				// .catch((error) => {
				//   // console.log(error);
				//   this.respuesta = error
				// });


    	},

      pagarMercadoPago () {
        
      }
    },

    computed:{
      ...mapGetters('productos',['getProductos'])
    }

  }
</script>


